import Utils from "../utils/utils";
import { DadosContratosModel } from './../model/dados-contrato.model';

export class DadosTermoRevogacaoPerfilMock {

    retornarServicosStr(servicos) {
        const pulaLinha = '\r\n';
        let servicosStr = pulaLinha;
        servicos.forEach(function (servico) {
            servicosStr = servicosStr.concat(servico).concat(pulaLinha);
        });
        return servicosStr;
    }

    textoTermoRevogacaoJuridico(infoContratos: DadosContratosModel): String {
        const pulaLinha = '\r\n';
        const titulo = 'TERMO DE REVOGAÇÃO DO CONTRATO ';
        const termo = titulo.concat(pulaLinha)
        .concat("   Pelo presente instrumento, CAIXA ECONÔMICA FEDERAL, com sede no Setor Bancário Sul, Quadra 4, Lotes 3 e 4 - CEP 70092 - 900, Brasília - DF, CGC 00360305/0001-04, neste ato representada por ")
            .concat(infoContratos.razaoSocial + "").concat(", doravante denominada CAIXA, e, de outro lado, a empresa ").concat(infoContratos.razaoSocial + "").concat(", com inscrição CGC/CNPJ/CEI n.º ")
            .concat(this.formatarInscricao(infoContratos.inscricao, infoContratos.tipoInscricao)).concat(', ')    
            .concat("doravante denominada CLIENTE, ajustam e celebram este convênio para os fins e sob as condições adiante indicadas.")
            .concat(pulaLinha)
            .concat(" O presente termo tem por objetivo revogar o atual Termo do Contrato de Prestação de Serviço do CLIENTE, que possui os seguintes serviços:")
            .concat(pulaLinha)
            .concat("PERFIL:").concat(infoContratos.desPerfil)
            .concat(pulaLinha)
            .concat("Serviços Disponíveis:")
            .concat(pulaLinha)
            .concat(this.retornarServicosStr(infoContratos.servicos))
            //.concat(pulaLinha)
            .concat("____________________________________________")
            .concat("Local e data")
            .concat(pulaLinha)
            .concat(pulaLinha)
            .concat(pulaLinha)

            .concat("_____________________________________________")
            .concat("CAIXA ECONÔMICA FEDERAL")
            .concat(pulaLinha)
            .concat(pulaLinha)
            .concat(pulaLinha)

            .concat("______________________________________________")
            .concat("CLIENTE - Representante legal da Empresa")
            .concat(pulaLinha)
            .concat(pulaLinha)
            .concat(pulaLinha)


            .concat("Testemunhas:")
            .concat(pulaLinha)
            .concat(pulaLinha)
            .concat(pulaLinha)

            .concat("_______________________________")
            .concat(pulaLinha)
            .concat("CPF")
            .concat(pulaLinha)

            .concat("_______________________________")
            .concat(pulaLinha)
            .concat("CPF")



            ;

        return termo;
    }

    textoTermoRevogacaoFisico(infoContratos: DadosContratosModel): String {

        const pulaLinha = '\r\n';
        const titulo = 'TERMO DE REVOGAÇÃO DO CONTRATO';
    
       
        const termo = titulo.concat(pulaLinha)
            .concat("Pelo presente instrumento, CAIXA ECONÔMICA FEDERAL, com sede no Setor Bancário Sul, Quadra 4, Lotes 3 e 4 - CEP 70092 - 900, Brasília - DF, CGC 00360305/0001-04, neste ato representada por doravante denominada CAIXA, e, de outro lado, a empresa ")
            .concat(infoContratos.razaoSocial + "").concat(", com inscrição CPF n.º ")
            .concat(this.formatarInscricao(infoContratos.inscricao, infoContratos.tipoInscricao))
            .concat(", doravante denominada CLIENTE, ajustam e celebram este convênio para os fins e sob as condições adiante indicadas.")
            .concat(pulaLinha)
            .concat(" O presente termo tem por objetivo revogar o atual Termo do Contrato de Prestação de Serviço do CLIENTE, que possui os seguintes serviços:")
            .concat(pulaLinha)
            .concat("PERFIL:").concat(infoContratos.desPerfil)
            .concat(pulaLinha)
            .concat("Serviços Disponíveis:")
            .concat(pulaLinha)
            .concat(this.retornarServicosStr(infoContratos.servicos))
            //.concat(pulaLinha)
            .concat("____________________________________________")
            .concat("Local e data")
            .concat(pulaLinha)
            .concat(pulaLinha)
            .concat(pulaLinha)

            .concat("_____________________________________________")
            .concat("CAIXA ECONÔMICA FEDERAL")
            .concat(pulaLinha)
            .concat(pulaLinha)
            .concat(pulaLinha)

            .concat("______________________________________________")
            .concat("CLIENTE - Representante legal da Empresa")
            .concat(pulaLinha)
            .concat(pulaLinha)
            .concat(pulaLinha)


            .concat("Testemunhas:")
            .concat(pulaLinha)
            .concat(pulaLinha)
            .concat(pulaLinha)

            .concat("_______________________________")
            .concat(pulaLinha)
            .concat("CPF")
            .concat(pulaLinha)

            .concat("_______________________________")
            .concat(pulaLinha)
            .concat("CPF")



            ;

        return termo;


    }
    public formatarInscricao(inscricao, tipoInsc) {

        let inscricaoFormatada = Utils.formatarInscricao(inscricao, tipoInsc);
        switch (tipoInsc) {
          case '1':
            return Utils.mascararCNPJ(inscricaoFormatada);
          case '3':
            return Utils.mascararCPF(inscricaoFormatada);
          case '2':
            return Utils.mascararCEI(inscricaoFormatada);
        }
      }

}